<template>
  <v-container fluid class="py-6">
    <v-row>
      <v-col lg="2" cols="12"></v-col>
      <v-col  lg="8" cols="12">
        <v-card class="card-shadow border-radius-xl">
          <div class="border-bottom d-flex align-center px-4 py-4">
            <div class="d-flex align-center">
              <a href="javascript:;" class="text-decoration-none">
                <v-avatar size="48" rounded>
                  <v-img
                      v-if="false"
                    src="@/assets/img/team-4.jpg"
                    alt="profile-image"
                  ></v-img>
                  <v-btn
                      :ripple="false"
                      icon
                      outlined
                      rounded
                      width="25px"
                      height="25px"
                      class="me-2 border-danger"
                  >
                    <v-icon
                        size="8"
                        class="text-danger"
                    >
                      fas fa-exclamation
                    </v-icon>
                  </v-btn>
                </v-avatar>
              </a>
              <div class="mx-4">
                <a
                  href="javascript:;"
                  class="text-dark font-weight-600 text-sm text-decoration-none"
                  >{{ companyInfo.business_address }}</a
                >
                <small class="d-block text-muted">{{companyInfo.email}}</small>
              </div>
            </div>
            <div class="text-end ms-auto">
              <v-btn
                outlined
                color="#fff"
                class="font-weight-bolder bg-gradient-secondary py-4 px-7"
                small
              >
                <v-icon size="8">fas fa-eye pe-2</v-icon> {{ companyInfo.status }}
              </v-btn>
            </div>
          </div>
        </v-card>
        <v-card class="card-shadow border-radius-xl">
          <div class="px-4 pt-4 d-flex align-center">
            <h6 class="mb-0 text-h6 font-weight-bold text-typo">Notices</h6>
            <v-btn
                :ripple="false"
                elevation="0"
                color="#fff"
                class="font-weight-bolder btn-outline-primary py-4 px-6 ms-auto"
                small
            >
              View all
            </v-btn>
          </div>
          <div class="px-4 pb-2 pt-2">
            <div v-for="invoice in invoices" :key="invoice.date">
              <v-list-item :key="invoice.id" class="px-0 py-3 justify-between">
                <v-list-item-content class="py-0">
                  <div class="d-flex flex-column">
                    <h6 class="mb-1 text-dark font-weight-bold text-sm">
                      {{ invoice.id }}
                    </h6>
                    <span class="text-xs text-body">{{ invoice.date }}</span>
                  </div>
                </v-list-item-content>

                <v-list-item-content class="py-0 text-end">
                  <div class="d-flex align-left text-sm text-body">
                    <v-btn
                        color="#fff"
                        class="text-dark font-weight-bolder py-4 px-5 shadow-0 ms-auto"
                        small
                        simple
                    >
                      <v-icon size="15" class="rotate-180"
                      >fas fa-eye text-sm me-1</v-icon
                      >
                      View
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "Teams",
  data: function () {
    return {
      invoices: [
        {
          date: "March, 01, 2020",
          id: "Skipped Weeks",
          value: "$180",
        },
        {
          date: "February, 10, 2021",
          id: "Reminder Letter #1",
          value: "$250",
        },
        {
          date: "April, 05, 2020",
          id: "Reminder Letter #2",
          value: "$560",
        },
        {
          date: "June, 25, 2019",
          id: "Cancellation Notice",
          value: "$120",
        },
        {
          date: "March, 01, 2019",
          id: "Payments Reminder",
          value: "$300",
        },
      ],
      stories: [
        {
          image: require("@/assets/img/team-1.jpg"),
          user: "Abbie W",
        },
        {
          image: require("@/assets/img/team-2.jpg"),
          user: "Boris U",
        },
        {
          image: require("@/assets/img/team-3.jpg"),
          user: "Kay R",
        },
        {
          image: require("@/assets/img/team-4.jpg"),
          user: "Tom M",
        },
        {
          image: require("@/assets/img/team-5.jpg"),
          user: "Nicole N",
        },
        {
          image: require("@/assets/img/marie.jpg"),
          user: "Marie P",
        },
        {
          image: require("@/assets/img/bruce-mars.jpg"),
          user: "Bruce M",
        },
        {
          image: require("@/assets/img/ivana-squares.jpg"),
          user: "Sandra A",
        },
        {
          image: require("@/assets/img/kal-visuals-square.jpg"),
          user: "Katty L",
        },
        {
          image: require("@/assets/img/ivana-square.jpg"),
          user: "Emma O",
        },
        {
          image: require("@/assets/img/team-9.jpeg"),
          user: "Tao G",
        },
      ],
      page: 1,
      pageCount: 0,
      companyInfo: [],
      batchInfo: [],
      itemsPerPage: 10,
      timeline: [
        {
          title: "Order received",
          date: "22 DEC 7:20 PM",
          color: "#b0eed3",
          iconColor: "#1aae6f",
          icon: "ni-bell-55",
          btn: "secondary",
        },
        {
          title: "Generate order id #1832412",
          date: "22 DEC 7:21 AM",
          color: "#b0eed3",
          iconColor: "#1aae6f",
          icon: "ni-html5",
          btn: "secondary",
        },
        {
          title: "Order transmited to courier",
          date: "22 DEC 8:10 AM",
          color: "#b0eed3",
          iconColor: "#1aae6f",
          icon: "ni-cart",
          btn: "secondary",
        },
        {
          title: "Order delivered",
          date: "22 DEC 4:54 PM",
          color: "#b0eed3",
          iconColor: "#1aae6f",
          icon: "ni-check-bold",
          btn: "success",
        },
      ],
      documents: [
        {
          user: "Proof of Payment",
        },
        {
          user: "Director ID Document",
        },
        {
          user: "Proof of Residence",
        },
        {
          user: "NSSA Documentation",
        },
      ],
      headers: [
        {
          text: "Weeks #",
          align: "start",
          sortable: false,
          value: "week_range",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "Status",
          value: "status",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Received Date",
          value: "date_received",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Other",
          value: "other",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Unallocated",
          value: "unallocated_amount",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "General Fund",
          value: "general_fund",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Interest",
          value: "interest",
          class: "text-secondary font-weight-bolder opacity-7",
        },

        {
          text: "Total Amount",
          value: "total_amount",
          class: "text-secondary font-weight-bolder opacity-7",
        },

      ],
    };
  },
  computed: {
    ...mapState(['base_url']),
  },
  created() {
    this.getcompanyInfo()
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async getcompanyInfo() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/auth/my-organisation-info/', { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then(res => {
            if (res.status === 200) {
              this.companyInfo = res.data
              console.log(this.companyInfo)
              console.log(this.companyInfo)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
  },
};
</script>
